<template>
    <div class="hidden-form">
        <form @submit.prevent="inputConfirmed">
            <input type="text" v-model="input" ref="hiddenInputField" :disabled="disabled"/>
        </form>
    </div>
</template>

<script>
    export default {
        /*
        Hidden text input, catches focus on any click event
        (make sure only one such component is mounted).
         */
        name: "HiddenInput",
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                input: ''
            }
        },
        methods: {
            refocus() {
                let input = this.$refs.hiddenInputField;
                if (input !== undefined && input !== document.activeElement)
                    input.focus();
            },
            inputConfirmed() {
                this.$emit('inputConfirmed', this.input);
                this.input = '';
            }
        },
        mounted() {
            this.refocus();
            window.addEventListener('click', this.refocus);
        },
        destroyed() {
            window.removeEventListener('click', this.refocus);
        }
    }
</script>

<style scoped>
    .hidden-form {
       opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// HiddenInput.vue?23398630